import { CmsComponentTypeEnum } from '@models/enums/cms-component-type.enum';
import { TImageConfig, LinkObject, TGtmEvent } from '@models/interfaces';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';

export namespace Form {
  export const TypeEnum = CmsComponentTypeEnum.FORM;

  export interface SideContentItemConfig {
    headline: string;
    content: string;
    link?: LinkObject;
    socialLinks?: boolean;
    imageNodeId?: string;
    imageConfig?: TImageConfig;
  }

  export interface ComponentConfig extends BaseComponentConfig {
    formId: number;
    formHeadline?: string;
    headline: string;
    paragraphs: Form.SideContentItemConfig[];
    gtmEvent: TGtmEvent;
    emailRecepients?:any
  }
}
